import Model, { ID, Integer, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import Librariable from 'src/models/model/concerns/Librariable'
import Site from 'src/models/site/Site'

export const STAGES = {
  OPEN: 'open',
  PREPARE: 'prepare',
  DELIVER: 'deliver',
  COMPLETE: 'complete'
}
STAGES.ALL = _.values(STAGES)
STAGES.PREPARED = [STAGES.COMPLETE]
STAGES.UNPREPARED = [STAGES.PREPARE]
STAGES.DELIVERED = [STAGES.COMPLETE]
STAGES.UNDELIVERED = [STAGES.OPEN, STAGES.DELIVER]

export const OPERATIONS = {
  SEND: 'send',
  RETURN: 'return',
  PREPARE: 'prepare',
  REMAKE: 'remake',
  DELIVER: 'deliver',
  RECALL: 'recall',
  HOTSTART: 'hotstart',
  DISMISS: 'dismiss'
}
OPERATIONS.ALL = _.values(OPERATIONS)

// Ordered by specificity - higher groupings are more specific
// More specific groupings = more groups with fewer entries per group
export const GROUP_BY = {
  NONE: 'none',
  MODIFIERS: 'modifiers',
  VARIATION: 'variation',
  ITEM: 'item',
  DISPLAY_CATEGORY: 'display-category',
  PREPARATION_CATEGORY: 'preparation-category'
}
GROUP_BY.ALL = _.values(GROUP_BY)
GROUP_BY.PREPARING = [GROUP_BY.NONE, GROUP_BY.MODIFIERS]
GROUP_BY.SUMMARIZING = [GROUP_BY.MODIFIERS, GROUP_BY.VARIATION, GROUP_BY.ITEM, GROUP_BY.DISPLAY_CATEGORY, GROUP_BY.PREPARATION_CATEGORY]

export default class KitchenDisplayType extends Model {
  static name = 'KitchenDisplayType'

  static deletable = true
  static duplicatable = true
  static paginate = true
  static versioned = true

  static isConfiguration = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Kitchen]

  static define () {
    this.concerns = [Archivable, Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      site: {
        type: Site,
        default: null,
        reference: true,
        output: true
      },
      deliveryStages: {
        type: JsonArray,
        default: () => ([
          STAGES.OPEN,
          STAGES.COMPLETE
        ])
      },
      deliveryOperations: {
        type: JsonObject,
        default: () => ({
          send: false,
          return: false,
          prepare: true,
          remake: true,
          deliver: true,
          recall: true,
          hotstart: false
        })
      },
      preparationWindowMinutes: {
        type: Integer,
        default: 120
      },
      prepareBy: {
        type: String,
        default: 'none'
      },
      summarizeWindowMinutes: {
        type: Integer,
        default: 120
      },
      summarizeBy: {
        type: String,
        default: 'variation'
      },
      showSwipeControls: {
        type: Boolean,
        default: true
      },
      showScrollControls: {
        type: Boolean,
        default: true
      },
      showPreparationCountdown: {
        type: Boolean,
        default: false
      },
      showOrderName: {
        type: Boolean,
        default: true
      },
      showDeliveryLocations: {
        type: Boolean,
        default: true
      },
      showDeliveryPositions: {
        type: Boolean,
        default: false
      },
      showOrderOrigin: {
        type: Boolean,
        default: true
      },
      showEmployee: {
        type: Boolean,
        default: false
      },
      deliveryWindowMinutes: {
        type: Integer,
        default: 5
      }
    }

    this.computed = {
      deliveryStagesChips () {
        return _(this.deliveryStages).map(operation => _.startCase(operation)).value()
      },
      deliveryOperationsChips () {
        return _(this.$mh.objectToArray(this.deliveryOperations, { allKeys: OPERATIONS.ALL })).map(operation => _.startCase(operation)).value()
      }
    }
  }
}
